import { addRolesToOrganisationUser, updateOrganisationUser } from '@infuse/api/iam/organisation';
import { addRolesToTenantUser, updateTenantUser } from '@infuse/api/iam/tenant';
import { addRolesToUser, updateUser } from '@infuse/api/iam/user';
import { UserLevel } from '@infuse/iam/user/type';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { useGenericUpdateUser } from './generic/useGenericUpdateUser';

export const useUpdateUser = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.ORGANISATION) {
    return useGenericUpdateUser({
      apiFn: updateOrganisationUser,
      roleApiFn: addRolesToOrganisationUser,
      forcedParentId: user?.organisationId
    });
  } else if (level === UserLevel.TENANT) {
    return useGenericUpdateUser({
      apiFn: updateTenantUser,
      roleApiFn: addRolesToTenantUser,
      forcedParentId: user?.tenantId
    });
  }

  return useGenericUpdateUser({
    apiFn: updateUser,
    roleApiFn: addRolesToUser
  });
};
